import { render, staticRenderFns } from "./app-forgot-password-sent.vue?vue&type=template&id=3a12e8f2&scoped=true"
import script from "./app-forgot-password-sent.vue?vue&type=script&lang=js"
export * from "./app-forgot-password-sent.vue?vue&type=script&lang=js"
import style0 from "./app-forgot-password-sent.vue?vue&type=style&index=0&id=3a12e8f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a12e8f2",
  null
  
)

export default component.exports